import { Component, input, model } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { MatIconButton } from '@angular/material/button';

@Component({
  selector: 'dbx-columns-select',
  imports: [FormsModule, MatMenuModule, MatIconModule, MatCheckboxModule, TranslateModule, MatIconButton],
  templateUrl: './columns-select.component.html',
  styleUrl: './columns-select.component.scss',
  standalone: true,
})
export class ColumnsSelectComponent {
  displayedColumns = model.required<string[]>();
  allColumns = input.required<string[]>();
  translateKey = input.required<(column: string) => string>();

  selectColumn(column: string): void {
    this.displayedColumns.update((columns: string[]) => {
      if (columns.includes(column)) {
        return columns.filter((c) => c !== column);
      } else {
        const index = this.allColumns()
          .filter((c) => columns.includes(c) || c === column)
          .indexOf(column);
        const before = columns.slice(0, index);
        const after = columns.slice(index);
        return [...before, column, ...after];
      }
    });
  }
}
